import {
  BasketTracker,
  PriceTracker,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//tracker.types';
import {useTrackPageView} from '@aboutyou/tracking';
import {useEffect, useRef} from 'react';

const convertPriceTrackerIntoTrackingPrice = (price?: PriceTracker) => {
  return {
    withoutTax: price?.priceWithoutTax || -0,
    withTax: price?.fullPrice || -0,
    saleReductionWithTax: price?.saleReduction || 0,
    campaignReductionWithTax: price?.campaignReduction || 0,
    currency: price?.currencyCode || '*** NOT AVAILABLE ***',
    fullPrice: price?.fullPrice || 0,
    couponReductionWithTax: price?.couponReduction || 0,
  };
};

export const BasketTracketView = (
  props: BasketTracker & {isDataFetching: boolean},
) => {
  const trackBasketPageView = useTrackPageView();
  const eventSent = useRef(false);

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    if (props.isDataFetching || eventSent.current) {
      return;
    }

    trackBasketPageView({
      basket: {
        items: props.items.map(item => {
          return {
            key: item.key,
            product: {
              id: item.productId,
              name: item.name,
              url: item.url,
              brand: item.brand,
              colors: [],
              minPrice: convertPriceTrackerIntoTrackingPrice(item.minPrice),
              isSoldOut: item.isSoldOut,
              isSponsored: item.isSponsored,
              sponsoredType: item.sponsoredType,
              masterKey: item.masterKey || '*** NOT AVAILABLE ***',
              unitPrice: convertPriceTrackerIntoTrackingPrice(item.unitPrice),
            },
            variant: {
              id: item.size.sizeId,
              supplierId: item.size.suppliedId,
              sizeLabel:
                item.size.sizeLabel || '*** SIZE LABEL NOT AVAILABLE ***',
              price: convertPriceTrackerIntoTrackingPrice(item.unitPrice),
            },
            selectedQuantity: item.quantity,
            unitPrice: convertPriceTrackerIntoTrackingPrice(item.unitPrice),
            totalPrice: convertPriceTrackerIntoTrackingPrice(item.totalPrice),
          };
        }),
        total: convertPriceTrackerIntoTrackingPrice(props.basketTotalPrice),
      },
    });
    eventSent.current = true;
  }, [props.isDataFetching]);

  return null;
};
